var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1053.642,
    height: 246.355,
    viewBox: "0 0 1053.642 246.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10370",
    "data-name": "Group 10370",
    transform: "translate(-8607.773 -18385.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10352",
    "data-name": "Group 10352",
    transform: "translate(8522 18282.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_585",
    "data-name": "Polygon 585",
    d: "M1.5,0,3,7H0Z",
    transform: "translate(326 236)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_586",
    "data-name": "Polygon 586",
    d: "M1.5,0,3,7H0Z",
    transform: "translate(329 250) rotate(180)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_587",
    "data-name": "Polygon 587",
    d: "M1.5,0,3,7H0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 335.05, 241.623)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_588",
    "data-name": "Polygon 588",
    d: "M1.5,0,3,7H0Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 320.504, 244.621)",
    fill: "#33324d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10354",
    "data-name": "Group 10354",
    transform: "translate(8746 18178.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_593",
    "data-name": "Polygon 593",
    d: "M1.247,0,2.493,4.986H0Z",
    transform: "translate(324.888 236.199)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_594",
    "data-name": "Polygon 594",
    d: "M1.247,0,2.493,6.233H0Z",
    transform: "translate(327.381 247.418) rotate(180)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_595",
    "data-name": "Polygon 595",
    d: "M1.229,0,2.457,5.734H0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 332.4, 240.557)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_596",
    "data-name": "Polygon 596",
    d: "M1.229,0,2.457,5.733H0Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 320.485, 243.012)",
    fill: "#33324d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10355",
    "data-name": "Group 10355",
    transform: "translate(8736.373 18324.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_597",
    "data-name": "Polygon 597",
    d: "M1,0,2,4H0Z",
    transform: "translate(324 236.199)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_598",
    "data-name": "Polygon 598",
    d: "M1,0,2,5H0Z",
    transform: "translate(326 245.199) rotate(180)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_599",
    "data-name": "Polygon 599",
    d: "M.986,0l.986,4.6H0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 330.026, 239.695)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_600",
    "data-name": "Polygon 600",
    d: "M.986,0l.986,4.6H0Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 320.469, 241.665)",
    fill: "#33324d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10356",
    "data-name": "Group 10356",
    transform: "translate(8434.373 18149.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_601",
    "data-name": "Polygon 601",
    d: "M.831,0l.831,3.324H0Z",
    transform: "translate(323.392 236.199)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_602",
    "data-name": "Polygon 602",
    d: "M.831,0l.831,4.155H0Z",
    transform: "translate(325.054 243.678) rotate(180)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_603",
    "data-name": "Polygon 603",
    d: "M.819,0l.819,3.822H0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 328.4, 239.104)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_604",
    "data-name": "Polygon 604",
    d: "M.819,0l.819,3.822H0Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 320.457, 240.741)",
    fill: "#33324d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10358",
    "data-name": "Group 10358",
    transform: "translate(8287.373 18269.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_609",
    "data-name": "Polygon 609",
    d: "M1,0,2,4H0Z",
    transform: "translate(324 236.199)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_610",
    "data-name": "Polygon 610",
    d: "M1,0,2,5H0Z",
    transform: "translate(326 245.199) rotate(180)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_611",
    "data-name": "Polygon 611",
    d: "M.986,0l.986,4.6H0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 330.026, 239.695)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_612",
    "data-name": "Polygon 612",
    d: "M.986,0l.986,4.6H0Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 320.469, 241.665)",
    fill: "#33324d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10363",
    "data-name": "Group 10363",
    transform: "translate(9105.016 18344.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_625",
    "data-name": "Polygon 625",
    d: "M1.5,0,3,7H0Z",
    transform: "translate(326 236)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_626",
    "data-name": "Polygon 626",
    d: "M1.5,0,3,7H0Z",
    transform: "translate(329 250) rotate(180)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_627",
    "data-name": "Polygon 627",
    d: "M1.5,0,3,7H0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 335.05, 241.623)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_628",
    "data-name": "Polygon 628",
    d: "M1.5,0,3,7H0Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 320.504, 244.621)",
    fill: "#33324d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10365",
    "data-name": "Group 10365",
    transform: "translate(9329.016 18241.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_633",
    "data-name": "Polygon 633",
    d: "M1.247,0,2.493,4.986H0Z",
    transform: "translate(324.888 236.199)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_634",
    "data-name": "Polygon 634",
    d: "M1.247,0,2.493,6.233H0Z",
    transform: "translate(327.381 247.418) rotate(180)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_635",
    "data-name": "Polygon 635",
    d: "M1.229,0,2.457,5.734H0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 332.4, 240.557)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_636",
    "data-name": "Polygon 636",
    d: "M1.229,0,2.457,5.733H0Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 320.485, 243.012)",
    fill: "#33324d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10366",
    "data-name": "Group 10366",
    transform: "translate(9319.389 18386.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_637",
    "data-name": "Polygon 637",
    d: "M1,0,2,4H0Z",
    transform: "translate(324 236.199)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_638",
    "data-name": "Polygon 638",
    d: "M1,0,2,5H0Z",
    transform: "translate(326 245.199) rotate(180)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_639",
    "data-name": "Polygon 639",
    d: "M.986,0l.986,4.6H0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 330.026, 239.695)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_640",
    "data-name": "Polygon 640",
    d: "M.986,0l.986,4.6H0Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 320.469, 241.665)",
    fill: "#33324d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10367",
    "data-name": "Group 10367",
    transform: "translate(9017.389 18211.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_641",
    "data-name": "Polygon 641",
    d: "M.831,0l.831,3.324H0Z",
    transform: "translate(323.392 236.199)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_642",
    "data-name": "Polygon 642",
    d: "M.831,0l.831,4.155H0Z",
    transform: "translate(325.054 243.678) rotate(180)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_643",
    "data-name": "Polygon 643",
    d: "M.819,0l.819,3.822H0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 328.4, 239.104)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_644",
    "data-name": "Polygon 644",
    d: "M.819,0l.819,3.822H0Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 320.457, 240.741)",
    fill: "#33324d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10369",
    "data-name": "Group 10369",
    transform: "translate(8870.389 18331.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_649",
    "data-name": "Polygon 649",
    d: "M1,0,2,4H0Z",
    transform: "translate(324 236.199)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_650",
    "data-name": "Polygon 650",
    d: "M1,0,2,5H0Z",
    transform: "translate(326 245.199) rotate(180)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_651",
    "data-name": "Polygon 651",
    d: "M.986,0l.986,4.6H0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 330.026, 239.695)",
    fill: "#33324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_652",
    "data-name": "Polygon 652",
    d: "M.986,0l.986,4.6H0Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 320.469, 241.665)",
    fill: "#33324d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBg);
export default __webpack_public_path__ + "static/media/starBg.f307f58aa1e3e19c4ef867742cc9ce5e.svg";
export { ForwardRef as ReactComponent };